import { render } from "./SpuImageImportDialog.vue?vue&type=template&id=a785627e&scoped=true"
import script from "./SpuImageImportDialog.vue?vue&type=script&lang=js"
export * from "./SpuImageImportDialog.vue?vue&type=script&lang=js"

import "./SpuImageImportDialog.vue?vue&type=style&index=0&id=a785627e&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a785627e"]])

export default __exports__